import React, { Component } from 'react';
import PropTypes from "prop-types";
import axios from "axios";
import { API_URL, ERROR_HANDLE, GYM_TAG_UNIQUE_ID } from "config/constants";
import theme from '../../../Theme/theme';
import Spinner from '../../../components/LoadingSpinner';
import Button from "../../../components/UI/Button";
import SearchBox from "../../../components/SearchBox";
import "./style.css";

const SELECT_ALL_TEXT = "Select All"
const UNSELECT_ALL_TEXT = "Unselect All"
const SEARCH_TEXT = "Search by gym name"
const NO_GYM_FOUND = "No Gyms found"
const SELECTION_ICON = require('../../../assets/images/selection_icon.png');

class GymListModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            gymsList: [],
            filteredGyms: [],
            isLoading: true,
            gymsSelected: []
        }
        this.lastSelectedGymIndex = -1;
    }

    componentDidMount() {
        (this.props.gymsList && this.props.gymsList.length > 0) ?
            this.setState({ gymsList: this.props.gymsList, filteredGyms: this.props.gymsList, isLoading: false }, () => this.setState({
                gymsSelected: this.props.gymsSelected
            })) : this.getGymsList();
    }

    updateSelectedGymList() {
        this.setState({
            gymsSelected: this.props.gymsSelected
        })
    }

    getGymsList() {
        const access_token = localStorage.getItem("access_token");
        axios.get(`${API_URL}/admin/gyms/basicDetails`, {
            headers: {
                "x-access-token": access_token
            }
        }).then(res => {
            if (!res.error) {
                this.setState({
                    gymsList: res.data,
                    filteredGyms: res.data,
                    gymsSelected: this.props.selectAllGyms ? res.data : this.props.gymsSelected
                }, () => {
                    this.props.updateGymsList(this.state.gymsList)
                    this.props.selectAllGyms && this.props.updateSelectedGyms(this.state.gymsSelected)
                    this.props.showGymTag ? this.getGymTags() : this.setState({ isLoading: false })
                })
            } else {
                if (res.error === 'Invalid Auth Token') {
                    window.location.assign("/");
                }
                this.setState({ isLoading: false });
            }
        }).catch(err => {
            ERROR_HANDLE(err);
            this.setState({ isLoading: false });
        });
    }

    //This method gets called only if the gym tags list is available
    updateGymListWithGymTags(data) {
        let gymTagList = []
        data.forEach((gymTag) => {
            gymTagList.push({ gym_id: gymTag.id + GYM_TAG_UNIQUE_ID, gym_name: gymTag.name })
        })
        return gymTagList
    }

    getGymTags() {
        const access_token = localStorage.getItem("access_token");
        axios
            .get(`${API_URL}/tags`, {
                headers: {
                    "x-access-token": access_token
                }
            })
            .then(res => {
                if (!res.error && res.data) {
                    let updateGymList = this.updateGymListWithGymTags(res.data);
                    updateGymList.push(...this.state.gymsList);
                    let updateGymSelected = this.updateGymListWithGymTags(this.props.tagsSelected);
                    updateGymSelected.push(...this.state.gymsSelected);
                    this.setState({
                        gymsList: updateGymList,
                        filteredGyms: updateGymList,
                        gymsSelected: updateGymSelected
                    }, () => {
                        this.props.updateGymsList(this.state.gymsList)
                    })
                } else {
                    if (res.error === 'Invalid Auth Token') {
                        window.location.assign("/");
                    }
                }
                this.setState({ isLoading: false });
            })
            .catch(err => {
                ERROR_HANDLE(err);
                this.setState({ isLoading: false });
            });
    }

    addSelectedGyms(selectedGymsList, startIndex, endIndex) {
        for (var i = startIndex; i <= endIndex; i++) {
            const selectedGymIndex = this.state.gymsSelected.findIndex(gymDetail => gymDetail.gym_id == this.state.filteredGyms[i].gym_id)
            if (selectedGymIndex === -1) {
                selectedGymsList = [...selectedGymsList, this.state.filteredGyms[i]]
            }
        }
        return selectedGymsList
    }

    removeSelectedGyms(selectedGymsList, startIndex, endIndex) {
        //Obtain the index of the gyms need to be removed from the list.
        var selectedGymsIndex = [];
        for (var i = startIndex; i <= endIndex; i++) {
            const selectedGymIndex = selectedGymsList.findIndex(gymDetail => gymDetail.gym_id == this.state.filteredGyms[i].gym_id)
            selectedGymIndex !== -1 && selectedGymsIndex.push(selectedGymIndex);
        }
        //sort by reverse order, to avoid the splice() functionality messing up the indexes.
        selectedGymsIndex.sort(function (a, b) { return b - a; });
        //Splice the selectedGymsIndex from the selected Gyms List.
        for (var count = 0; count < selectedGymsIndex.length; count++)
            selectedGymsList.splice(selectedGymsIndex[count], 1);
        return selectedGymsList
    }

    updateSelectedGym(event, gym) {
        const index = this.state.gymsSelected.findIndex(gymDetail => gymDetail.gym_id == gym.gym_id);
        const currentSelectedIndex = this.state.filteredGyms.findIndex(gymDetail => gymDetail.gym_id == gym.gym_id);
        let selectedGymsList = [...this.state.gymsSelected]; // make a separate copy of the array
        const startIndex = (this.lastSelectedGymIndex >= 0 && event.shiftKey) ? Math.min(this.lastSelectedGymIndex, currentSelectedIndex) : currentSelectedIndex;
        const endIndex = (this.lastSelectedGymIndex >= 0 && event.shiftKey) ? Math.max(this.lastSelectedGymIndex, currentSelectedIndex) : currentSelectedIndex;
        if (index !== -1) {
            selectedGymsList = this.removeSelectedGyms(selectedGymsList, startIndex, endIndex)
        } else {
            selectedGymsList = this.addSelectedGyms(selectedGymsList, startIndex, endIndex)
        }
        //Updating the lastSelectedGymIndex with the currentSelectedIndex.
        this.lastSelectedGymIndex = currentSelectedIndex
        this.setState({
            gymsSelected: selectedGymsList
        }, () => this.props.updateSelectedGyms(this.state.gymsSelected));
    }

    selectAllGyms() {
        this.setState({
            gymsSelected: [...this.state.gymsList]
        }, () => this.props.updateSelectedGyms(this.state.gymsSelected))
    }

    unSelectAllGyms() {
        this.setState({
            gymsSelected: []
        }, () => this.props.updateSelectedGyms(this.state.gymsSelected))
    }

    renderGymList() {
        return (
            this.state.filteredGyms.length > 0 ? <div style={style.container}>
                {this.state.filteredGyms.map((gym, index) => {
                    const gymIndex = this.state.gymsSelected.findIndex(gymDetail => gymDetail.gym_id == gym.gym_id);
                    const city = gym.address && gym.address.includes(",") > 0 ? ", " + gym.address.split(",")[1] : ""
                    const gymContainerStyle = gym.gym_id.toString().includes(GYM_TAG_UNIQUE_ID) ? { ...style.gymNameContainer, ...{ background: theme.color.lightGreen } } : style.gymNameContainer
                    return (
                        gym.gym_name && <div key={"gymList" + index} style={gymContainerStyle} onClick={(event) => this.updateSelectedGym(event, gym)}>
                            <div style={style.gymName}>{gym.gym_name}{city}</div>
                            {(gymIndex >= 0) && <img style={{ width: 25, height: 25, marginTop: -4 }} src={SELECTION_ICON} />}
                        </div>
                    )
                })}
            </div> : <div style={{ ...style.container, ...style.alertContainer }}> {NO_GYM_FOUND}</div>
        )
    }

    renderSearchGymsButton = () => {
        return (
            <div style={style.searchGymContainer}>
                <SearchBox
                    hideSearchImage={true}
                    placeholder={SEARCH_TEXT}
                    searchWrapperStyle={style.searchWrapper}
                    searchInputStyle={style.searchInput}
                    onChange={(e) => this.searchHandler(e)}>
                </SearchBox>
                {<div style={style.selectGymCount}>{this.state.gymsSelected.length}</div>}
            </div>
        );
    }

    renderSelectGymsButton = () => {
        return (
            < div style={style.selectGymButtonContainer} >
                <Button
                    style={this.state.gymsList.length === this.state.gymsSelected.length ? { ...style.selectButton, ...{ background: theme.color.mediumPrimaryBlue } } : style.selectButton}
                    type="primary"
                    onClick={() => this.selectAllGyms()}
                >
                    {SELECT_ALL_TEXT}
                </Button>
                <Button
                    style={this.state.gymsSelected.length === 0 ? { ...style.selectButton, ...{ background: theme.color.mediumPrimaryBlue } } : style.selectButton}
                    type="primary"
                    onClick={() => this.unSelectAllGyms()}
                >
                    {UNSELECT_ALL_TEXT}
                </Button>
            </div >
        )
    }

    searchHandler = (e) => {
        const filteredGyms = this.state.gymsList.filter(gym => {
            const gymName = gym.gym_name;
            return gym.gym_name && gymName.toLowerCase().includes(e.target.value.toLowerCase()) > 0
        })
        this.setState({ filteredGyms })
    }

    render() {
        return (
            this.state.isLoading ? <Spinner loading={this.state.isLoading} /> :
                <div>
                    {this.renderSelectGymsButton()}
                    {this.renderSearchGymsButton()}
                    {this.renderGymList()}
                </div>
        )
    }
}

GymListModal.propTypes = {
    gymsList: PropTypes.array.isRequired,
    gymsSelected: PropTypes.array.isRequired,
    updateGymsList: PropTypes.func.isRequired,
    updateSelectedGyms: PropTypes.func.isRequired,
    showGymTag: PropTypes.bool,
    selectAllGyms: PropTypes.bool,
    tagsSelected: PropTypes.array,
};

GymListModal.defaultProps = {
    showGymTag: true,
    selectAllGyms: false,
    tagsSelected: []
};

const style = {
    container: {
        display: 'flex',
        width: 400,
        height: 350,
        overflowY: "auto",
        flexDirection: 'column',
        alignItems: 'center',
        backgroundColor: theme.color.white,
        boxShadow: "1px 2px 4px " + theme.color.shadowColor,
        borderRadius: "0px 0px 10px 10px",
        marginBottom: 8
    },
    gymNameContainer: {
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        height: 60,
        width: "100%",
        borderBottom: "2px solid " + theme.color.tableSeparatorGrey
    },
    gymName: {
        width: "86%",
        verticalAlign: "middle",
        textAlign: "left",
        lineHeight: "60px",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        paddingLeft: 10,
        fontSize: 17,
        letterSpacing: 0,
        fontFamily: theme.font.avenirMedium,
        color: theme.color.thickGrey
    },
    alertContainer: {
        height: 150,
        justifyContent: "center",
        fontSize: 26,
        fontFamily: theme.font.glacialIndifference,
        fontWeight: theme.fontWeight.bold,
        fontStyle: theme.fontWeight.regular,
        color: theme.color.thickGrey,
        textAlign: 'center',
        background: theme.color.white
    },
    selectGymButtonContainer: {
        display: "flex",
        width: "100%",
        justifyContent: "space-between",
        alignItems: "center"
    },
    selectButton: {
        width: 150,
        fontSize: 17,
        marginBottom: 10,
        borderRadius: 8,
        height: 40,
        color: theme.color.thickGrey,
        backgroundColor: theme.color.white,
        borderStyle: "solid",
        borderWidth: 1,
        borderColor: theme.color.primaryBlue
    },
    searchGymContainer: {
        display: "flex",
        width: "100%",
        justifyContent: "flex-start",
        alignItems: "center",
        borderRadius: "10px 10px 0px 0px",
        boxShadow: "1px 2px 4px " + theme.color.shadowColor,
        lineHeight: "60px",
        backgroundColor: theme.color.black
    },
    selectGymCount: {
        textAlign: "center",
        fontSize: 20,
        lineHeight: "50px",
        height: "50px",
        width: "50px",
        borderRadius: "25px",
        backgroundColor: theme.color.white,
        fontFamily: theme.font.avenirBlackOblique,
        color: theme.color.black
    },
    selectGymButton: {
        textAlign: "center",
        fontSize: 28,
        fontFamily: theme.font.avenirHeavyOblique,
        color: theme.color.white
    },
    searchWrapper: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        margin: "10px",
        width: "80%",
        position: "relative"
    },
    searchInput: {
        backgroundColor: theme.color.lightGrey,
        borderRadius: 32,
        borderWidth: 2,
        borderStyle: "solid",
        borderColor: theme.color.white,
        fontSize: 20,
        fontFamily: theme.font.avenirHeavyOblique,
        color: theme.color.searchTextGrey,
        width: "100%",
        paddingLeft: 20,
        textAlign: "left"
    }
};

export default GymListModal;

